module.exports = __webpack_public_path__ + "img/alter_tours_logo_new.41dec1dc.jpeg";